module.exports = __webpack_public_path__ + "img/people-22-min.b0484831.png";